export const months = [
  { label: 'Jan', value: 1, text: 'January' },
  { label: 'Feb', value: 2, text: 'February' },
  { label: 'Mar', value: 3, text: 'March' },
  { label: 'Apr', value: 4, text: 'April' },
  { label: 'May', value: 5, text: 'May' },
  { label: 'Jun', value: 6, text: 'June' },
  { label: 'Jul', value: 7, text: 'July' },
  { label: 'Aug', value: 8, text: 'August' },
  { label: 'Sep', value: 9, text: 'September' },
  { label: 'Oct', value: 10, text: 'October' },
  { label: 'Nov', value: 11, text: 'November' },
  { label: 'Dec', value: 12, text: 'December' },
];

const twentyNineDays = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
  '24',
  '25',
  '26',
  '27',
  '28',
  '29',
];
const thirtyDays = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
  '24',
  '25',
  '26',
  '27',
  '28',
  '29',
  '30',
];
const thirtyOneDays = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
  '24',
  '25',
  '26',
  '27',
  '28',
  '29',
  '30',
  '31',
];

export const days = {
  1: thirtyOneDays,
  2: twentyNineDays,
  3: thirtyOneDays,
  4: thirtyDays,
  5: thirtyOneDays,
  6: thirtyDays,
  7: thirtyOneDays,
  8: thirtyOneDays,
  9: thirtyDays,
  10: thirtyOneDays,
  11: thirtyDays,
  12: thirtyOneDays,
};
